type AppEnv = 'local' | 'staging' | 'production'

function readApiUrl(): string {
  const raw = import.meta.env.VITE_API_URL
  if (typeof raw !== 'string' || raw.length === 0) {
    throw new Error('VITE_API_URL is not set')
  }
  try {
    const url = new URL(raw)
    return url.toString().replace(/\/$/, '')
  } catch {
    throw new Error(`VITE_API_URL is not a valid URL: ${raw}`)
  }
}

function readAppEnv(): AppEnv {
  const raw = import.meta.env.VITE_APP_ENV
  if (raw === 'staging' || raw === 'production') return raw
  return 'local'
}

export const env = {
  apiUrl: readApiUrl(),
  appEnv: readAppEnv(),
} as const
